//libs
import { useState } from "react";
//components
import AddQuestionModal from "./AddQuestionModal";
import QuestionsAndAnswersTable from "./QuestionsAndAnswersTable";

export default function QuestionsAndAnswers({ tender }: { tender: any }) {
  const [open, setOpen] = useState(false);
  const isTender = tender.opportunity_type === 1;

  return (
    <div className="pt-2 grid grid-cols-4 rounded-md w-full">
      <div className="col-span-full">
        <AddQuestionModal
          tenderId={tender.id}
          open={open}
          setOpen={setOpen}
          isTender={isTender}
        />
        <QuestionsAndAnswersTable
          setOpen={setOpen}
          tenderId={tender.id}
          isTender={isTender}
        />
      </div>
    </div>
  );
}
